import axios, { AxiosInstance, AxiosResponse } from "axios";
import config from "@/utils/cognitoUrlConfig";
import { TheTeam } from "@/models/the-team";

class TeamService {
  client: AxiosInstance;

  constructor(jwt: string) {
    this.client = axios.create({
      baseURL: config.apiURL,
      withCredentials: false,
      headers: {
        Authorization: jwt,
      }
    });
  }

  async getTeams(): Promise<AxiosResponse<TheTeam[]>> {
    return await this.client.get("/teams");
  }
}

export default TeamService;
